
import { defineComponent, ref, computed, watch, SetupContext } from 'vue';

export default defineComponent({
  name: 'RangeSlider',
  props: {
    valueMin: {
      type: Number,
      default: 20,
    },
    valueMax: {
      type: Number,
      default: 80,
    },
  },
  setup(props, { emit }: SetupContext) {
    const minVal = ref<number>(props.valueMin);
    const maxVal = ref<number>(props.valueMax);

    const handleMinChange = () => {
      if (minVal.value > maxVal.value - 1) {
        minVal.value = maxVal.value - 1;
      }
      emitValues();
    };

    const handleMaxChange = () => {
      if (maxVal.value < minVal.value + 1) {
        maxVal.value = minVal.value + 1;
      }
      emitValues();
    };

    const emitValues = () => {
      emit('update', { min: minVal.value, max: maxVal.value });
    };

    // Sync with props
    watch(
      () => props.valueMin,
      (val) => (minVal.value = val),
    );
    watch(
      () => props.valueMax,
      (val) => (maxVal.value = val),
    );

    const minPercent = computed(() => (minVal.value / 100) * 100);
    const maxPercent = computed(() => (maxVal.value / 100) * 100);
    const rangeWidth = computed(() => maxPercent.value - minPercent.value);

    return {
      minVal,
      maxVal,
      handleMinChange,
      handleMaxChange,
      minPercent,
      maxPercent,
      rangeWidth,
    };
  },
});
